import { Link } from "react-router-dom";
import { PROGRAMS } from "@/data/programs";
import ProgramImage from "@/components/ProgramImage";
import { ArrowRight, Heart } from "lucide-react";

export default function Programs() {
  return (
    <div data-testid="programs-page">
      <section className="bg-brandnavy">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-24">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent">SEAA Programs</span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-black tracking-tight text-white max-w-3xl">
            Real-world exposure. Structured growth.
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-slate-300 leading-relaxed">
            Each program connects hands-on industry experiences with structured learning and performance readiness — building
            real skills, strengthening discipline, and helping students apply academic concepts in meaningful ways.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 space-y-8">
        {PROGRAMS.map((p, i) => (
          <div
            key={p.slug}
            data-testid={`program-row-${p.slug}`}
            className={`grid lg:grid-cols-2 gap-8 lg:gap-12 items-center rounded-3xl border border-slate-100 bg-white p-6 sm:p-8 shadow-sm ${
              i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
            }`}
          >
            <div className="relative overflow-hidden rounded-2xl h-64 sm:h-80">
              <ProgramImage program={p} />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.15em]" style={{ color: p.color }}>
                {p.tag}
              </p>
              <h2 className="mt-2 font-display text-2xl sm:text-3xl font-black text-brandnavy">{p.name}</h2>
              <p className="mt-4 text-slate-600 leading-relaxed">{p.description}</p>
              <ul className="mt-5 flex flex-wrap gap-2">
                {p.outcomes.map((o) => (
                  <li key={o} className="rounded-full bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-700">
                    {o}
                  </li>
                ))}
              </ul>
              <Link
                to={`/programs/${p.slug}`}
                data-testid={`program-detail-link-${p.slug}`}
                className="mt-6 inline-flex items-center gap-2 font-semibold text-brandnavy hover:text-accent transition-colors"
              >
                View program <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-orange-50">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-black text-brandnavy">Ready to get your child involved?</h2>
          <p className="mt-3 text-slate-600">Reach out to enroll, or help us bring these programs to more youth.</p>
          <div className="mt-7 flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="programs-enroll-cta" className="inline-flex items-center gap-2 rounded-full bg-brandnavy px-7 py-3.5 font-semibold text-white transition-all hover:-translate-y-0.5">
              Enroll / Contact Us
            </Link>
            <Link to="/support" data-testid="programs-donate-cta" className="inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-orange-400">
              <Heart className="h-4 w-4 fill-current" /> Donate
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
